export const ADD_SIGNAL = 'signal.ADD_SIGNAL';